module.exports = __webpack_public_path__ + "img/LT112043462.b7dab79b.png";